/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

import type { Optional } from '../@types/common';

/**
 * Determines if the given optional was provided a value.
 * @param s - The optional to test.
 * @returns True if the value is defined.
 */
export function isProvided<T>(s: Optional<T>): s is T {
  return s !== null && s !== undefined;
}

/**
 * Determines if the given optional string is a defined string.
 * @param s - The input string.
 * @returns True if the input is a defined string.
 */
export function isOptionalAString(s: Optional<string>): s is string {
  return isProvided(s) && typeof s === 'string';
}
